import React from "react";
import owl from "../assets/athena_owl.svg";

export default function Empty({ title = "Sin resultados", message }) {
  return (
    <div className="empty">
      <img src={owl} alt="" className="athena-owl" width={64} height={74} />
      <h3>{title}</h3>
      {message && <p>{message}</p>}
    </div>
  );
}
